import { ArrowPathIcon } from '@heroicons/react/24/outline';

/**
 * Shown by a route guard when the data that decides access (entitlements,
 * integrations) FAILED to load: a 5xx or network error is not a denial, so the
 * guard must not redirect as if access were refused.
 *
 * @param {{ onRetry: () => void }} props
 */
export default function AccessCheckFailed({ onRetry }) {
  return (
    <div role="alert" className="flex min-h-64 items-center justify-center bg-gray-50 p-6 dark:bg-gray-900">
      <div className="max-w-sm text-center">
        <p className="font-medium text-gray-900 dark:text-white">Couldn&apos;t check access to this page.</p>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">This is usually temporary. Try again in a moment.</p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 inline-flex cursor-pointer items-center gap-2 rounded-lg bg-teal-600 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-teal-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 dark:!bg-teal-600 dark:text-white dark:hover:!bg-teal-700"
        >
          <ArrowPathIcon className="h-4 w-4" aria-hidden="true" />
          Retry
        </button>
      </div>
    </div>
  );
}
